import React from "react";

const whyuse = [
  {
    title: "",
    description:
      "Available doctor on call 24 hours a day, 7 days a week, 365 days a year!",
    icon: "",
  },
  {
    title: "",
    description: "We treat infants, children, adolescents, and adults",
    icon: "",
  },
  {
    title: "",
    description:
      "Provide urgent and non-urgent care for any medical conditions, including mental and behavioral health.",
    icon: "no-border-edge",
    class: "flex-cell is-bordered no-border-edge",
  },
  {
    title: "",
    description: "Same day medications pick up from your nearest pharmacy. ",
    icon: "",
    class: "flex-cell",
  },
  {
    title: "",
    description:
      "Quick access to diagnostic tests at any general hospital.",
    icon: "",
    class: "flex-cell",
  },
  {
    title: "",
    description:
      "Calls and Chat messages are 100% secure, confidential, and compliant with Nigeria Medical Association Regulations.",
    icon: "",
    class: "flex-cell no-border-edge",
  },
];

export const SectionPage = () => {
  return (
    <div className="section is-light-grey">
      <div className="container">
        <div className="cta-block mb-6">
          <div className="head-text " style={{ textAlign: "center" }}>
            <h3>With 24Telemed eConsult Services</h3>
            <p>
              You have 24/7 access to qualified and experienced doctors in
              Nigeria from the comfort of your home.
              <br />
              You can schedule appointments with doctors and specialists in
              Nigeria.
              <br />
              You can get prescriptions sent to your pharmacy or delivered to
              your doorstep.
            </p>
          </div>
        </div>
        <div
          id="premium-features"
          className="section-title has-text-centered pt-0"
        >
          <h2 className="title is-2 is-bold is-narrow">Why 24Telemed?</h2>
        </div>
        <div className="landing-boxed-features" >
          <div className="card">
            {whyuse.map((e, i) => {
              return (
                <div className={e.class || `flex-cell is-bordered `} >
                  <i className="las la-check-circle" />
                  <h3>{e.title}</h3>
                  <p>{e.description}</p>
                </div>
              );
            })}
          </div>
        </div>


      </div>
    </div>
  );
};
<div class="row row-cols-1 row-cols-md-3 g-4">
  <div class="col">
    <div className="card" id="box">
      {whyuse.map((e, i) => {
        return (
          <div className={e.class || `flex-cell is-bordered `} >
            <i className="las la-check-circle" />
            <h3>{e.title}</h3>
            <p>{e.description}</p>
          </div>
        );
      })}
    </div>
  </div>
</div>